module.exports = __webpack_public_path__ + "media/images/icons/filled/tags-b64f27e4f3c6c7fd5eb52126fa610f21.svg";